var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappTemplateCallPhonenumberIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.993,
    height: 22,
    viewBox: "0 0 21.993 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call-_192_",
    "data-name": "call-[#192]",
    d: "M68.6,7180.063c-.679,2.052-3.339,3.079-5.239,2.918a16.633,16.633,0,0,1-7.563-3.139,24.938,24.938,0,0,1-7.822-9.324c-1.216-2.581-1.488-5.763.32-8.123A3.135,3.135,0,0,1,50.772,7161c1.507-.073,1.718.792,2.236,2.141.386,1,.9,2.023,1.188,3.064.538,1.95-1.343,2.023-1.581,3.606-.148,1.013,1.066,2.347,1.614,3.065a14.754,14.754,0,0,0,3.824,3.519c.834.527,2.182,1.48,3.138.953,1.472-.807,1.333-3.284,3.391-2.448,1.066.439,2.1,1.07,3.116,1.612,1.573.851,1.5,1.716.9,3.549-.449,1.349.449-1.364,0,0",
    transform: "translate(-47 -7160.997)",
    fill: "#00a5f4",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappTemplateCallPhonenumberIcon);
export default __webpack_public_path__ + "static/media/whatsapp-template-call-phonenumber-icon.b7517b6126d87ebdddb50058d54331a5.svg";
export { ForwardRef as ReactComponent };